import _ from 'lodash'
import React from 'react'
import * as blueprint from '@adc/blueprint'
import ScrollSpy from '../../../layouts/scrollspy'
import ListingBadge, { BADGE_ORDER_PRIORITY, BADGE_MODE } from './base'
import FullWidthBadge from './fullWidthBadge'
import { isPrivateSeller } from './utils'

class CashOnlyBadge extends ListingBadge {
  static title = 'Cash Only'

  static titleIcon = 'money-bill'

  static contentPositive = false

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed. Hidden for private seller
    // — payment is conveyed by the Accepted Payment badge there.
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      !isPrivateSeller(listing) &&
      !_.get(listing, 'listing_configuration.financing_available', false)
    )
  }

  getState() {
    return _.get(
      this.props.listing,
      'primary_property.summary.address.country_primary_subdivision'
    )
  }

  get title() {
    const state = this.getState()

    if (
      blueprint.listing.utils.isForeclosure(this.props.listing) &&
      state &&
      blueprint.listing.constants.CERTIFIED_FUNDS_STATES.includes(state)
    ) {
      return 'Certified Funds Preferred'
    }

    return CashOnlyBadge.title
  }

  get content() {
    const state = this.getState()
    const trustee = _.get(this.props.listing, 'event.trustee_sale', false)

    if (
      blueprint.listing.utils.isForeclosure(this.props.listing) &&
      state &&
      blueprint.listing.constants.CERTIFIED_FUNDS_STATES.includes(state)
    ) {
      return (
        <>
          To bid on site at this auction, please have funds in the form of
          cashiers check or other certified funds present
        </>
      )
    }

    return (
      <>
        Conventional financing is <strong>NOT</strong> accepted for this
        property.{' '}
        <ScrollSpy selector='#prepare_your_finances'>
          {({ scrollTo }) => (
            <a onClick={scrollTo}>
              {trustee ? 'What should I bring?' : 'Learn more'}
            </a>
          )}
        </ScrollSpy>
      </>
    )
  }
}

class FinancingAvailableBadge extends FullWidthBadge {
  static summary = 'Eligible for Financing'

  static titleIcon = 'money-bill'

  static condensedTitle = 'Financing Available'

  static renderPriority = BADGE_ORDER_PRIORITY.FIFTH

  static shouldBeHoisted = true

  static shouldBeIncluded(listing) {
    // applies to all modes
    return _.get(listing, 'listing_configuration.financing_available', false)
  }

  get content() {
    return (
      <>
        Buyers are responsible for determining financing eligibility prior to
        bidding.{' '}
        <ScrollSpy selector='#prepare_your_finances'>
          {({ scrollTo }) => <a onClick={scrollTo}>Learn More</a>}
        </ScrollSpy>
      </>
    )
  }
}

export { CashOnlyBadge, FinancingAvailableBadge }
